import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { MediaReducer } from '@synergy/data-access';
import { combineReducers } from 'redux';

import { AppState } from './store/models/app-state';
import { accountReducer } from './common/reducers/account-reducer';
import { accountsReducer } from './common/reducers/accounts-reducer';
import { bonusSettlementsReducer } from './features/bonus-settlements/store/bonus-settlements-reducer';
import { contactsLoginsReducer } from './common/reducers/contacts-logins-reducers';
import { currencyReducer } from './common/reducers/currency-reducer';
import { currentLocaleReducer } from './common/reducers/current-locale-reducer';
import { demandsReducer } from './features/demands/store/demands-reducer';
import { inquiryReducer } from './features/inquiry/store/inquiry-reducers';
import { localesReducer } from './common/reducers/locales-reducer';
import { notificationsReducer } from './common/reducers/notifications-reducers';
import { positionsReducer } from './common/reducers/positions-reducers';
import { settingsReducer } from './common/reducers/settings-reducer';
import { supplierReducer } from './common/reducers/supplier-reducer';
import { supportedCurrenciesReducer } from './common/reducers/supported-currencies-reducer';
import { userReducer } from './common/reducers/user-reducer';

export const rootReducer = combineReducers<AppState>({
    currentLocale: currentLocaleReducer,
    supportedLocales: localesReducer,
    user: userReducer,
    account: accountReducer,
    accounts: accountsReducer,
    suppliers: supplierReducer,
    demands: demandsReducer,
    contactsLogins: contactsLoginsReducer,
    currency: currencyReducer,
    supportedCurrencies: supportedCurrenciesReducer,
    media: MediaReducer,
    settings: settingsReducer,
    notifications: notificationsReducer,
    positions: positionsReducer,
    bonusSettlements: bonusSettlementsReducer,
    inquiry: inquiryReducer,
    [Snackbar.name]: Snackbar.reducer,
});
